<template>
  <div class="loading-overlay" :hidden="hidden">
    <v-progress-circular
      :color="this.$store.state.mainColor"
      :indeterminate="indeterminate"
      :width="width"
      :size="64"
    ></v-progress-circular>
  </div>
</template>
<script>
  export default {
    name: 'LoadingOverlay',
    data () {
      return {
        hidden: true,
        hideTimeout: '.25', // optional hide timeout (milliseconds * 1000)
        width: 7, // width of the circular progress bar
        indeterminate: true,
        size: 64 // height and width of the circular bar
      }
    },
    created () {
      this.$root.$on(this.$store.state.events.ajax, (state) => {
        if (state) {
          this.hidden = false
          return
        }
        setTimeout(() => {
          this.hidden = !state
        }, this.hideTimeout * 1000)
      })
    }
  }
</script>
<style>
.loading-overlay,
.loading-overlay .progress-circular
{
  position: fixed;
}

.loading-overlay
{
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, .5);
  cursor: wait;
}

.loading-overlay .progress-circular
{
  top: 50%;
  left: 50%;
  margin: -32px 0 0 -32px;
}
</style>


// WEBPACK FOOTER //
// src/components/LoadingOverlay.vue